import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import SvgIcon from '@material-ui/core/SvgIcon';
import Tooltip from '@material-ui/core/Tooltip';
import NativeSelect from '@material-ui/core/NativeSelect';
import OrderedSupplier from "./OrderedSupplier.js";
import { Link } from 'react-router-dom';
import '../../Styles/customerForm.css';


// id={this.props.customer.id}
// products={this.props.customer.product}
// supplierConfig={this.props.supplierConfig}
// users={this.props.users}
// langPairs={this.props.langPairs}
						
class SupplierConfiguration extends Component {
	constructor() {
		super();
		
		this.state={ 
			selectProd: 0,
			selectUser: 0,
			selectTranslator: 0,
			loading: false,
		}
		
		this.listSupplierCongigs = this.listSupplierCongigs.bind(this);
		this.renderSupplierConfigForm = this.renderSupplierConfigForm.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleSupplierConfigChange = this.handleSupplierConfigChange.bind(this);
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.supplierConfig !== this.props.supplierConfig) {
			this.setState({selectProd:0, selectUser:0, selectTranslator:0, loading: false});
		}
	}
	
	handleDelete(producId, supConfId){
		this.props.addSupplierConfig(producId, 0, this.props.supplierConfig[supConfId].supplier);
	}
	
	handleSupplierConfigChange(e) {
		e.preventDefault();
		const {name, value} = e.target;
		this.setState({[e.target.name]: e.target.value }, function() {
			if(this.state.selectProd>0 && this.state.selectUser>0 && this.state.selectTranslator>0){
				this.props.addSupplierConfig(this.state.selectProd, this.state.selectUser, this.state.selectTranslator);
//				this.setState({selectProd:0, selectUser:0, selectTranslator:0});
				this.setState({loading:true});
			}
		});
		
	}
	
	renderSupplierConfigForm(){
		// Products
		const prodList = [];
		prodList.push(<option value={0}></option>);
		this.props.products.forEach(product => prodList.push(<option value={product.id}>{product.name} {this.props.langPairs[product.langPair].code}</option>));
		let productSelect = <NativeSelect name="selectProd" value={this.state.selectProd} onChange={this.handleSupplierConfigChange} style={{ width: "100%" }}>{prodList}</NativeSelect>
		
		// Customer users
		const custUsersList = [];
		custUsersList.push(<option value={0}></option>);
		Object.keys(this.props.users).forEach(userId => {if(this.props.users[userId].hasOwnProperty('customer') && this.props.users[userId].customer===this.props.id){custUsersList.push(<option value={this.props.users[userId].id}>{this.props.users[userId].username}</option>);} })
		let custUserSelect = <NativeSelect name="selectUser" value={this.state.selectUser} onChange={this.handleSupplierConfigChange} style={{ width: "100%" }}>{custUsersList}</NativeSelect>
		
		// Translators
		const translatorList = [];
		translatorList.push(<option value={0}></option>);
		if(this.state.selectProd>0){
			this.props.products.forEach(product => {
					if(product.id.toString()===this.state.selectProd) {
						product.suppliers.forEach(supConfId => 
							translatorList.push(<option value={this.props.users[this.props.supplierConfig[supConfId].supplier].id}>{this.props.users[this.props.supplierConfig[supConfId].supplier].username}</option>)
						)
					}
				}
			);
		}
		let translatorSelect = <NativeSelect name="selectTranslator" value={this.state.selectTranslator} onChange={this.handleSupplierConfigChange} style={{ width: "100%" }}>{translatorList}</NativeSelect>
		
		return(<div className="row"><div className="col-4">{productSelect}</div><div className="col-3">{custUserSelect}</div><div className="col-3">{translatorSelect}</div></div>)
	}
	
	listSupplierCongigs(){
		let rows = [];
		this.props.products.forEach(
			product => {let langPairId =  product.langPair;
						let producName =  product.name;
						let producId =  product.id;
						product.suppliers.forEach(
							supConfId => {
								if(this.props.supplierConfig[supConfId].hasOwnProperty('customerUser')){
									rows.push(<tr>
													<td>{producName} {this.props.langPairs[langPairId].code}</td>
													<td>{this.props.users[this.props.supplierConfig[supConfId].customerUser].username}</td>
													<td>{this.props.users[this.props.supplierConfig[supConfId].supplier].username}</td>
													<td><Tooltip title="Delete"><HighlightOffIcon style={{fontSize: "21px", color: "#b26d6d", cursor: "pointer"}} onClick={() => { this.handleDelete(producId, supConfId); }}/></Tooltip></td>
												</tr>)
								}
							})
						});
		if(rows.length>0){
			return(<table className="table table-striped table-hover lst">
						<thead><tr><th scope="col">Language</th><th scope="col">Customer user</th><th scope="col">Translator</th><th scope="col">Actions</th></tr></thead>
						<tbody>{rows}</tbody>
					</table>);
		}else{
			return("");
		}
	}
	
	render() {
		//console.log("SupplierConfiguration");
		//supplierConfigs = listSupplierCongigs();
		
		return (<div>{this.listSupplierCongigs()}{this.renderSupplierConfigForm()}</div>)
	}
}

export default SupplierConfiguration;